// ⚠ 빌더 프리뷰 전용 라우트 (builder_preview_split.html → Vue 3 구현)
// 기존 /builder 하위 라우트와 별도로, /builder/preview 하위에 위치
// 기존 BuilderView.vue, BuilderSide.vue, builderRoutes.js 수정 없음

export default [
  { path: "", redirect: "/builder/preview/studyInfo" },
  {
    path: "dashboard",
    name: "PreviewDashboard",
    component: () => import("../form/builderPreview/PreviewDashboard.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "studyInfo",
    name: "PreviewStudyInfo",
    component: () => import("../form/builderPreview/PreviewStudyInfo.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "subject",
    name: "PreviewSubject",
    component: () => import("../form/builderPreview/PreviewSubject.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "criteria",
    name: "PreviewCriteria",
    component: () => import("../form/builderPreview/PreviewCriteria.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "regimen",
    name: "PreviewRegimen",
    component: () => import("../form/builderPreview/PreviewRegimen.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "visitTemplate",
    name: "PreviewVisitTemplate",
    component: () => import("../form/builderPreview/PreviewVisitTemplate.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "visitTest",
    name: "PreviewVisitTest",
    component: () => import("../form/builderPreview/PreviewVisitTest.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "surveyManagement",
    name: "PreviewSurveyManagement",
    component: () => import("../form/admin/SurveyManagement.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "visitSurvey",
    name: "PreviewVisitSurvey",
    component: () => import("../form/builderPreview/PreviewVisitSurvey.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "adverseEvent",
    name: "PreviewAdverseEvent",
    component: () => import("../form/builderPreview/PreviewAdverseEvent.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "responseEval",
    name: "PreviewResponseEval",
    component: () => import("../form/builderPreview/PreviewResponseEval.vue"),
    meta: { requiresAuth: false, title: "Builder Preview" },
  },
  {
    path: "mockPreview",
    name: "PreviewMockView",
    component: () => import("../form/builderPreview/PreviewMockView.vue"),
    meta: {
      requiresAuth: false,
      title: "Builder Preview",
      hideSideMenu: false,
    },
  },
];
